// TODO: those enums should be provided by the back-end
export enum SponsorshipHistoryRequestState {
  Pending = 10,
  Accepted = 20,
  Acquired = 25,
  Refused = 30,
}
